export default {
  getCurrentUserMessage (state, payload) {
    state.currentUserMessage = payload
  }
}